export function removeBrand() {
  const brand = document.querySelector('.brand');
  brand.remove();
}
